import axios from "axios";
import { CONFIG } from "../config";
import { setupAuthInterceptors } from "../utils/auth";

const api = setupAuthInterceptors(
  axios.create({
    baseURL: CONFIG.BACKEND_URL,
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
  }),
);

const buildQuery = ({ startYmd, endYmd, deviceId }) => {
  const base = `startYmd=${startYmd}&endYmd=${endYmd}`;
  return deviceId ? `${base}&deviceId=${deviceId}` : base;
};

// ── 통합 대시보드 ──────────────────────────────────────────────

export const getIntegratedSummary = async ({ startYmd, endYmd }) => {
  const res = await api.get(
    `/dashboard/summary?startYmd=${startYmd}&endYmd=${endYmd}`,
  );
  return res.data;
};

export const getIntegratedDevicesCharts = async ({ startYmd, endYmd }) => {
  const res = await api.get(
    `/dashboard/devices/charts?startYmd=${startYmd}&endYmd=${endYmd}`,
  );
  return res.data;
};

// ── 단지별 대시보드 (deviceId 생략 시 전체 합산) ───────────────

export const getDeviceStats = async (params) => {
  const res = await api.get(`/dashboard/devices/stats?${buildQuery(params)}`);
  return res.data;
};

export const getDeviceDaily = async (params) => {
  const res = await api.get(`/dashboard/devices/daily?${buildQuery(params)}`);
  return res.data;
};

export const getDeviceDow = async (params) => {
  const res = await api.get(`/dashboard/devices/dow?${buildQuery(params)}`);
  return res.data;
};

export const getDeviceHourly = async (params) => {
  const res = await api.get(`/dashboard/devices/hourly?${buildQuery(params)}`);
  return res.data;
};

export const getDeviceDestination = async (params) => {
  const res = await api.get(
    `/dashboard/devices/destination?${buildQuery(params)}`,
  );
  return res.data;
};

// ── 원본 데이터 다운로드 (deviceId 생략 시 전체 포함) ──────────

export const downloadRawDataExcel = async (params) => {
  const res = await api.get(`/dashboard/rawData/excel?${buildQuery(params)}`, {
    responseType: "blob",
  });
  return res;
};
